import Provider         from '../../common/model/Provider'
import Config           from '../../common/model/Config'
import GlobalVar        from '../../common/model/GlobalVar'
import { webAccess }    from '../../common/controller/webAccessibilityCtrl'
import { common }       from '../../common/controller/validationCtrl'
import { device }       from '../../common/utils/deviceCheck'
import { providerChk }  from '../../common/utils/provider.id.check'
import {viewAsyn}       from './viewAsynProcessing'
import {vaild}          from './validationCtrl'
import {viewEvent}      from './viewEventCtrl'
import UmdOption from '../../common/model/UmdOption'

var rootId = "";
var pcMobileId = "";
export const mobile = {
    init: ()=>{
        rootId = Config.appendElementTagId;
        pcMobileId = GlobalVar.pcMobileId;
        //Keyboard Events
        mobile.keyboard_events();
        mobile.telcoTycd_select_events();
        mobile.form_events();
    },
    serviceSelect: ()=>{

        //개인정보이용동의(필수)
        $(`${rootId} #m_policy1_btn`).on('click',()=>{
            $(`${rootId} ${pcMobileId} #view_policy1`).addClass("view");
            webAccess.targetFocus(`${rootId} ${pcMobileId} #view_policy1 .policy .cont`);
        })
        //서비스이용약관동의(필수)
        $(`${rootId} #m_policy2_btn`).on('click',()=>{
            $(`${rootId} ${pcMobileId} #view_policy2`).addClass("view");
            webAccess.targetFocus(`${rootId} ${pcMobileId} #view_policy2 .policy .cont`);
        })
        //제3자 정보제공동의(필수)
        $(`${rootId} #m_policy3_btn`).on('click',()=>{
            $(`${rootId} ${pcMobileId} #view_policy3`).addClass("view");
            webAccess.targetFocus(`${rootId} ${pcMobileId} #view_policy3 .policy .cont`);
        })
        //고유식별정보처리동의(필수)
        $(`${rootId} #m_policy4_btn`).on('click',()=>{
            $(`${rootId} ${pcMobileId} #view_policy4`).addClass("view");
            webAccess.targetFocus(`${rootId} ${pcMobileId} #view_policy4 .policy .cont`);
        })
        
        //서비스 선택
        $(`${rootId} ${pcMobileId} .oacx_providerList li input[type=radio]`).on('focusout',(e)=>{
            $(`${rootId} ${pcMobileId} .oacx_providerList li .logoBg`).removeClass("label-focus");
        })
        $(`${rootId} ${pcMobileId} .oacx_providerList li input[type=radio]`).on('focusin',(e)=>{
            $(`${rootId} ${pcMobileId} .oacx_providerList li .logoBg`).removeClass("label-focus");
            $(e.currentTarget).closest("li").find(".logoBg").addClass("label-focus");
        })
        $(`${rootId} ${pcMobileId} .oacx_providerList li`).on('click',(e)=>{
            $(`${rootId} ${pcMobileId} .oacx_providerList li`).removeClass('selected');
            $(e.currentTarget).addClass('selected');
            $(`${rootId} ${pcMobileId} .oacx_providerList li`).removeAttr("title");
            $(e.currentTarget).find("a").attr("title","선택됨")

            Provider.providerId = $(e.currentTarget).find("input").val();
            var provider_txt = $(e.currentTarget).find("input").attr("title");
            $(`${rootId} .selectedService dd`).text(provider_txt);
            $(`${rootId} .selectedService`).show();
            
            if(Provider.compareCI == false && providerChk.isSamsung(Provider.providerId)){
                viewEvent.hideBirthSsn();
            }else{
                viewEvent.showBirthSsn();
            }

            if(providerChk.isPass(Provider.providerId)){
                $(`${rootId} ${pcMobileId} .telecom`).show();
                $(`${rootId} ${pcMobileId} .none-telecom`).hide();
                if(device.isMobileUI()){
                    if($(`${rootId} .mobileView [data-id='oacx_phone3']`).val() == ""){
                        var pv = $(`${rootId} .mobileView [data-id='oacx_phone3']`).val();
                        $(`${rootId} .mobileView [data-id='oacx_phone3']`).val(pv);
                    }
                }
            }else{
                $(`${rootId} .telecom`).hide();
                $(`${rootId} .none-telecom`).show();
                if(device.isMobileUI()){
                    if($(`${rootId} .mobileView [data-id='oacx_phone2']`).val() == ""){
                        var pv = $(`${rootId} .mobileView [data-id='oacx_phone2']`).val();
                        $(`${rootId} .mobileView [data-id='oacx_phone2']`).val(pv);
                    }
                }
            }

            if(device.isMobileUI()){
                $(`${rootId} #msg_kica`).hide();
                //인증완료 대기화면 인증기관 메시지
                if(providerChk.isSamsung(Provider.providerId)){
                    $(`${rootId} #msg_kica`).show();
                }
            }

            //입력 Form Check
            if(mobile.isAllFormValue()){
                //개인정보 동의
                mobile.nextView();
            }
        })
    },
    nextView: ()=>{
        setTimeout(()=>{
            $(`${rootId} input`).blur();
            $(`${rootId} .mAgreeBg`).addClass("view");
            webAccess.targetFocus(`${rootId} .mAgree`)
        }, 100);
    },
    isAllFormValue: ()=>{
        const name = common.trim($(`${rootId} ${pcMobileId} [data-id='oacx_name']`).val());
        const num1 = common.trim($(`${rootId} ${pcMobileId} [data-id='oacx_num1']`).val());
        const num2 = common.trim($(`${rootId} ${pcMobileId} [data-id='oacx_num2']`).val());
        const birth = common.trim($(`${rootId} ${pcMobileId} [data-id='oacx_birth']`).val());
        const providerId =$(`${rootId} ${pcMobileId} li.selected input[name=provider]`).val();
        var phone = "";

        if(Provider.isBirth){
            if(name == "" || birth == ""){
                webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_name']`)
                return false;
            }
        }else{
            if(name == "" || num1 == "" || num2 == ""){
                webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_name']`)
                return false;
            }
        }
        
        if(providerChk.isPass(providerId)){
            phone = common.trim($(`${rootId} ${pcMobileId} [data-id='oacx_phone3']`).val());
            if(phone == ""){
                webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_name']`)
                return false;
            }
            const telcoTycd = $(`${rootId} ${pcMobileId} [data-id='oacx_phone0'] option:not([value=select]):selected`).val();
            if(telcoTycd == "" || telcoTycd == null || telcoTycd === undefined){
                viewEvent.view_msg("안내","","통신사를 선택해주세요.", ()=>{
                    webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone0']`);
                });
                return false;
            }
        }else{
            phone = common.trim($(`${rootId} ${pcMobileId} [data-id='oacx_phone2']`).val());
            if(phone == ""){
                webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_name']`)
                return false;
            }
        }
        return true;
    }, 
    telcoTycd_select_events: ()=>{
        $(`${rootId} ${pcMobileId} [data-id='oacx_phone0'], ${rootId} ${pcMobileId} [data-id='oacx_phone1']`).on('change', function() {

            //입력 Form Check
            if(mobile.isAllFormValue()){
                //개인정보 동의
                mobile.nextView();
            }else{
                webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone2']`);
            }
        });
    },
    keyboard_events: ()=>{
        rootId = Config.appendElementTagId;
        pcMobileId = GlobalVar.pcMobileId;
        $(`${rootId} ${pcMobileId} [data-id='oacx_phone2'], ${rootId} ${pcMobileId} [data-id='oacx_phone3'], 
        ${rootId} ${pcMobileId} [data-id='oacx_name'], ${rootId} ${pcMobileId} [data-id='oacx_birth'], 
        ${rootId} ${pcMobileId} [data-id='oacx_num1'], ${rootId} ${pcMobileId} [data-id='oacx_num2']`).on("keyup", (e)=>{
            var id =  $(e.currentTarget).attr("data-id");
            var value = $(e.currentTarget).val().trim();
            if(e.which !== 13 && e.which !== 9 && e.which !== 16 && e.which !== 8){
                mobile.keyboard_events_allkey(id,value);
            }
        })
        $(`${rootId} ${pcMobileId} [data-id='oacx_phone2'], ${rootId} ${pcMobileId} [data-id='oacx_phone3'], 
        ${rootId} ${pcMobileId} [data-id='oacx_name'], ${rootId} ${pcMobileId} [data-id='oacx_birth'], 
        ${rootId} ${pcMobileId} [data-id='oacx_num1'], ${rootId} ${pcMobileId} [data-id='oacx_num2']`).on("keydown", (e)=>{
            var id =  $(e.currentTarget).attr("data-id");
            var value = $(e.currentTarget).val().trim();
            if(e.which === 13){
                mobile.keyboard_events_enter(id,value);
            }
        })
    },
    keyboard_events_enter: (id, value)=>{
        switch (id) {
            case "oacx_name":
                if(!vaild.nameCheck(value)){
                    return false;
                }
                if(Provider.isBirth){
                    webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_birth']`);
                }else{
                    webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_num1']`);
                }
                break;
            case "oacx_birth":
                if(!vaild.birthCheck(value)){
                    return false;
                }
                
                if(providerChk.isPass(Provider.providerId)){
                    webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone0']`)
                }else{
                    webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone2']`);
                }
                break;
            case "oacx_num1":
                if(!vaild.ss1NumCheck(value)){
                    return false;
                }
                webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_num2']`);
                break;
            case "oacx_num2":
                if(!vaild.ss2NumCheck(value)){
                    return false;
                }
                
                if(providerChk.isPass(Provider.providerId)){
                    webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone0']`);
                }else{
                    webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone2']`);
                }
                break;
            case "oacx_phone2":
                if(!vaild.phoneCheck(value)){
                    return false;
                }
                viewEvent.formValidation_popup()
                break;
            case "oacx_phone3":
                if(!vaild.phoneCheck(value)){
                    return false;
                }
                viewEvent.formValidation_popup()
                break;
            default:
                break;
        }
    },
    keyboard_events_allkey: (id, value)=>{
        switch (id) {
            case "oacx_birth":
                if(value.length >= 8){
                    $(`${rootId} ${pcMobileId} [data-id=${id}]`).val(value.slice(0,8));
                    if(providerChk.isPass(Provider.providerId)){
                        webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone0']`);
                    }else{
                        webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone2']`);
                    }
                }
                break;
            case 'oacx_num1':
                if(value.length >= 6){
                   $(`${rootId} ${pcMobileId} [data-id='${id}']`).val(value.slice(0,6));
                   webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_num2']`);
                }
                break;
            case 'oacx_num2':
               if(value.length >= 7){
                    $(`${rootId} ${pcMobileId} [data-id='${id}']`).val(value.slice(0,7));
                    if(providerChk.isPass(Provider.providerId)){
                        webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone0']`);
                    }else{
                        webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_phone2']`);
                    }
               }
                break;
            case 'oacx_phone2':
               if(value.length >= 8){
                    $(`${rootId} ${pcMobileId} [data-id='${id}']`).val(value.slice(0,8));
                   viewEvent.formValidation_popup()
               }
               break;
            case 'oacx_phone3':
               if(value.length >= 8){
                    $(`${rootId} ${pcMobileId} [data-id='${id}']`).val(value.slice(0,8));
                   viewEvent.formValidation_popup()
               }
               break;
            default:
                break;
        }
    },
    form_events: ()=>{
        $(`${rootId} ${pcMobileId} [data-id='oacx_phone0'], ${rootId} ${pcMobileId} [data-id='oacx_phone2'], ${rootId} ${pcMobileId} [data-id='oacx_phone3'], 
            ${rootId} ${pcMobileId} [data-id='oacx_name'], ${rootId} ${pcMobileId} [data-id='oacx_birth'], ${rootId} ${pcMobileId} [data-id='oacx_num1'], ${rootId} ${pcMobileId} [data-id='oacx_num2']`).on('focusin', (e)=>{
            const providerId =$(`${rootId} ${pcMobileId} .oacx_providerList li.selected input[name=provider]`).val();
            if(providerId === undefined || providerId == ""){
                /* alert(`
                ✔ Device Code: ${Provider.deviceInfo.code}
                ✔ UI Class: ${pcMobileId}
                ✔ Select Provider Id: ${providerId}
                `) */
                $(`${rootId} ${pcMobileId} input`).blur();
                viewEvent.view_msg("안내","","인증서비스를 선택하여 주십시오.", ()=>{
                    webAccess.targetFocus(`${rootId} ${pcMobileId} .oacx_providerList li:lt(1) a`);
                    $(`${rootId} .main section`).scrollTop(0,0);
                });
                return false;
            }

            var id = $(e.currentTarget).attr("data-id");
            $(`${rootId} .selectedService`).show();
            if(id != "oacx_name"){
                $(`${rootId} .main section`).scrollTop(document.body.scrollHeight);
            }
        })
        
        //약관동의 닫기
        $(`${rootId} .mAgreeBg .close`).on('click', ()=>{
            $(`${rootId} .mAgreeBg`).removeClass("view");
            webAccess.targetFocus(`${rootId} #mAgreeCstBtn`)
        })

        //약관 동의 다음 단계
        $(`${rootId} #mAgreeBtn`).on('click', (e)=>{
            mobile.hide_agree_button();
            if(viewEvent.formValidationCheck()){
                if(UmdOption.callback.event.request() === false){ 
                    return false; 
                }
                viewAsyn.requestAuth();
            }  
        })
        
        //약관 동의 창 팝업
        $(`${rootId} #mAgreeCstBtn`).on('click', ()=>{
            mobile.show_agree_button();
            if(viewEvent.formValidationCheck()){
                //개인정보 동의
                mobile.nextView();
            }  
        })
    },    
    show_agree_button: ()=>{
        $(`${rootId} #mAgreeBtn`).removeClass("disabled").removeAttr("disabled");
    },
    hide_agree_button: ()=>{
        $(`${rootId} #mAgreeBtn`).addClass("disabled").prop("disabled",true);
    }
}